// src/Dashboard/pages/user/Absences/components/AbsenceAdherentSelect.jsx

import React from "react";
import { FaSearch } from "react-icons/fa";

export default function AbsenceAdherentSelect({ adherents, value, onChange }) {
  return (
    <div className="rounded-[24px] border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-900/60">
      <label className="mb-2 flex items-center gap-2 text-sm font-bold text-slate-800 dark:text-slate-100">
        <FaSearch className="text-slate-400" />
        Sélectionner un adhérent
      </label>

      <select
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="w-full rounded-2xl border border-slate-300 bg-white px-3 py-3 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
      >
        <option value="">— Choisir un adhérent —</option>

        {adherents.map((adherent) => (
          <option key={adherent.id} value={adherent.id}>
            {adherent.prenom} {adherent.nom}
          </option>
        ))}
      </select>
    </div>
  );
}